import { render, staticRenderFns } from "./AccessSettingsForm.vue?vue&type=template&id=340de627&"
import script from "./AccessSettingsForm.vue?vue&type=script&lang=js&"
export * from "./AccessSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports